module.exports = __webpack_public_path__ + "app/announcement/modals/modal-delete-announcement-29-2L-M3.html";